document.addEventListener('DOMContentLoaded', function() {
  // 通过事件委托监听点击（解决动态类名问题）
  document.body.addEventListener('click', function(e) {

    // 通过 DOM 结构特征定位元素（不依赖具体类名）
    const btnlink = e.target.closest('div > a > div > span'); 
    // const imglink = e.target.closest('div > a > img'); 

    if (!btnlink) return;

    // 获取父级 a 标签的 href（优惠码在链接中）
    const parentLink = btnlink.closest('a');
    const targetUrl = parentLink.href;
    
    // 解析 URL 中的 code 参数
    const url = new URL(targetUrl);
    const couponCode = url.searchParams.get('couponCode');

    if (couponCode) {
      e.preventDefault(); // 阻止跳转
      navigator.clipboard.writeText(couponCode)
        .then(() => {
          // 可选：显示自定义提示（非 alert）
          // const toast = document.createElement('div');
          // toast.textContent = `已复制优惠码：${couponCode}`;
          // toast.style.position = 'fixed';
          // toast.style.bottom = '20px';
          // toast.style.right = '20px';
          // toast.style.background = '#222';
          // toast.style.color = '#fff';
          // toast.style.padding = '10px';
          // document.body.appendChild(toast);
          // setTimeout(() => toast.remove(), 2000);
        })
        .catch(() => {
          prompt('手动复制优惠码：', couponCode);
        });
    }
  });
});